import { PaletteColor } from '@mui/material'

declare module '@mui/material/styles' {
	interface Palette {
		gameDressUp: Palette['primary']
	}

	interface PaletteOptions {
		gameDressUp?: PaletteOptions['primary']
	}
}

declare module '@mui/material/Alert' {
	interface AlertPropsColorOverrides {
		gameDressUp: true
	}
}

export const gameDressUpColor = {
	main: '#2B5084',
	light: '#E7F8FF',
} as PaletteColor
